import { Colors } from '@sigma-frontend-libs/commons'

import { permissionColors, services, sizes } from '@/utils'

import tag from '@/components/tag'

function renderLabel(h) {
  return h(
    tag,
    {
      props: {
        label: this.label,
        size: sizes.small,
        as: this.as,
        color: Colors.black
      }
    }
  )
}
function renderPermission(h) {
  return h(
    tag,
    {
      props: {
        label: this.options.permission.toUpperCase(),
        tooltip: this.getTranslate(`${services.permissions}.tooltips.accepts.${this.options.permission}`),
        size: sizes.small,
        as: this.as,
        color: permissionColors[this.options.permission]
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'settings-fields__header'
    },
    [
      renderLabel.call(this, h),
      renderPermission.call(this, h)
    ]
  )
}
